/**
 * @file src/graphql/GraphQLRequestError.ts
 * @exports GraphQLRequestError
 * @summary Preserves GraphQL error details and the transport cause alongside the client-facing message.
 * @remarks `cause` carries the transport error, when there was one, so callers can read its HTTP status.
 */

import type { GraphQLFormattedError } from "graphql";

/** Keeps the server error payload available to callers that need structured extensions. */
export class GraphQLRequestError extends Error {
	readonly graphQLErrors: readonly GraphQLFormattedError[];

	constructor({
		cause,
		errors,
		message,
	}: {
		cause?: unknown;
		errors: readonly GraphQLFormattedError[];
		message: string;
	}) {
		super(message, { cause });
		this.name = "GraphQLRequestError";
		this.graphQLErrors = errors;
	}
}
